import { useEffect, useState } from 'react'
import { jsonrpc } from '~/shared/api/jsonrpc'
import { useZone } from '~/team_tools/components/timezone'
import { useWindowParams } from '~/team_tools/dashboard/statistic/period'

/** One People series (`statistic.accounts.people.*`): a count per period and a
 *  history to chart, fetched for the dashboard's window and zone. The same two
 *  calls Accounts makes, so every People figure reads the same way. */
export const usePeopleSeries = (series: string) => {
    const [zone] = useZone()
    const window = useWindowParams()
    const [counts, setCounts] = useState<Record<string, number>>({})
    const [history, setHistory] = useState<Record<string, number>>({})

    useEffect(() => {
        let live = true
        setHistory({})
        jsonrpc('statistic.accounts.people.count', {
            series,
            periods: ['total', 'today', 'week', 'month'].concat(window.custom ? ['custom'] : []),
            tz: zone,
            ...window.figure,
        }).then((resp) => live && setCounts(resp.result || {}))
        jsonrpc('statistic.accounts.people.history', { series, ...window.history, tz: zone }).then(
            (resp) => live && setHistory(resp.result || {})
        )
        return () => {
            live = false
        }
    }, [series, zone, window.key])

    return { counts, history }
}

export const formatCount = (value: number | undefined) =>
    value === undefined || value === null ? undefined : Number(value).toLocaleString('en-US')
